/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pre_Render_Frame_Cache_Cancelled_ToastInputs */



/**
* | output |
* | --- |
* | "Frame cache pre-render cancelled" |
*
* @param {Pre_Render_Frame_Cache_Cancelled_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const pre_render_frame_cache_cancelled_toast = /** @type {((inputs?: Pre_Render_Frame_Cache_Cancelled_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pre_Render_Frame_Cache_Cancelled_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pré-génération du cache d'images annulée")
	if (locale === "de") return /** @type {LocalizedString} */ ("Frame-Cache-Vorrendering abgebrochen")
	if (locale === "it") return /** @type {LocalizedString} */ ("pre-rendering della cache dei frame annullato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предварительная отрисовка кэша кадров отменена.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Precarga de caché de fotogramas cancelada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("帧缓存预渲染已取消")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フレームキャッシュのプリレンダリングがキャンセルされました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ्रेम कैश प्री-रेंडर रद्द कर दिया गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pré-renderização do cache de quadros cancelada")
	return /** @type {LocalizedString} */ ("Frame cache pre-render cancelled")
});